var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0ffb304a52f4d2528fc77345bd4a63905fe6cb88"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["admin-app@tucar-spa"]={id:"0ffb304a52f4d2528fc77345bd4a63905fe6cb88"};
      